import { render } from "./Select.vue?vue&type=template&id=68a69028&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=68a69028&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-68a69028"

export default script